import React, { useEffect } from 'react';
import clsx from 'clsx';
import { DEFooter } from 'components/Footers/DEFooter/DEFooter';
import { LoggedOutNavigation } from 'components/Navigation/LoggedOutNavigation';
import { Navigation } from 'components/Navigation/Navigation';
import { useAmplitude } from 'hooks/useAmplitude';
import { useLocale } from 'hooks/useLocale';
import { Helmet } from 'react-helmet';
import { getCookie } from 'utils/cookieHelper';
import { getEnvironment } from 'utils/environmentHelper/environmentHelper';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from './BaseLayout.module.css';

type Props = {
  children: React.ReactNode;
  className?: string;
  pageTitle: string;
  showDEFooter?: boolean;
  contentPadding?: boolean;
};

export const BaseLayout = ({
  children,
  className,
  pageTitle,
  showDEFooter = false,
  contentPadding = true,
}: Props) => {
  const isLoggedIn = getCookie('isLoggedIn') === 'True';
  const { isDE } = useLocale();
  const { trackEvent } = useAmplitude();

  useEffect(() => {
    trackEvent(
      AMPLITUDE_EVENTS.introducerPortalVisited,
      {
        'Page name': pageTitle,
        URL: window.location.pathname,
      },
      { includePageData: false },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageTitle]);

  showDEFooter = showDEFooter && isDE;

  return (
    <div>
      <Helmet>
        <title>{pageTitle}</title>
        <meta property="og:title" content={pageTitle} key="title" />
      </Helmet>
      <div>
        {isLoggedIn ? <Navigation /> : <LoggedOutNavigation />}
        <main
          className={clsx(
            styles.mainContent,
            { [styles.contentPadding]: contentPadding },
            { [styles.hasFooter]: showDEFooter },
            { [styles.isStaging]: getEnvironment() === 'staging' },
            className,
          )}
        >
          {children}
        </main>
        {showDEFooter && <DEFooter />}
      </div>
    </div>
  );
};
